import {
  Alert,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import React from 'react';

import { useGetTimeRecords } from '../hooks/reactQuerys/TimeRecordQueries';
import { ITimeRecording } from '../Interfaces/ITimeRecording';
import { TimeRecordOwn } from './TimeRecordOwn';

type IProps = {
  open: boolean;
  onClose: () => void;
};

const Layout = ({
  children,
  open,
  onClose,
}: IProps & { children: React.ReactNode }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='lg' fullWidth>
      <DialogTitle>Zeiterfassung</DialogTitle>
      {children}
    </Dialog>
  );
};

export const TimeRecordDialog = ({ open, onClose }: IProps) => {
  const queryClient = useQueryClient();
  const { timeRecords, isLoadingTimeRecords, refetchTimeRecords } =
    useGetTimeRecords();

  if (isLoadingTimeRecords) {
    return (
      <Layout open={open} onClose={onClose}>
        <DialogContent
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '50vh',
          }}
        >
          <CircularProgress />
        </DialogContent>
      </Layout>
    );
  }

  if (!timeRecords) {
    return (
      <Layout open={open} onClose={onClose}>
        <DialogContent
          sx={{
            minHeight: '50vh',
          }}
        >
          <Alert severity='error'>Fehler!</Alert>
        </DialogContent>
      </Layout>
    );
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth='lg' fullWidth>
      <DialogTitle>Zeiterfassung</DialogTitle>
      <DialogContent>
        <TimeRecordOwn
          isBookCurrentDay
          timeRecordArray={timeRecords}
          setTimeRecordArray={(timeRecords: ITimeRecording[]) => {
            queryClient.setQueryData(['timeRecords'], timeRecords);
            refetchTimeRecords();
          }}
          setIsOpenDialog={onClose}
        />
      </DialogContent>
    </Dialog>
  );
};
